module.exports = __webpack_public_path__ + "img/765.8479f590.jpg";